export enum CompareValue {
  EqualTo = 'equalTo',
  NotEqualTo = 'notEqualTo',
  GreaterThan = 'greaterThan',
  LessThan = 'lessThan',
  GreaterThanEqualLessThanEqual = 'greaterThanEqualLessThanEqual',
  GreaterThanLessThan = 'greaterThanLessThan',
  InList = 'inList'
}

export interface OutputValue {
  id: CompareValue;
  min?: number;
  max?: number;
  values: number[] | string[];
  /** asset:inUse only: seconds the state must have been held before the condition matches */
  minDuration?: number;
}
